import React from 'react';
import proptypes from 'prop-types';
import { Link, Typography } from '@one-thd/sui-atomic-components';
import { publishAnalytics } from '../../../../utils';

const { string } = proptypes;

// Same event as the table layout's view-order arrow, so tile clicks report like classic's.
function publishViewOrderClickEvent() {
  publishAnalytics('recentPurchases.view-order-arrow-click');
}

export function RecentPurchasesTableReceipt({ orderReceiptDetails = null }) {
  const receiptNumber = orderReceiptDetails || '';

  return (
    <div
      data-testid="receiptDetails"
      className="sui-flex sui-items-center sui-break-words sui-overflow-hidden sui-h-20"
    >
      <Typography variant="body-base">
        <span className="sui-break-all">{receiptNumber}</span>
      </Typography>
    </div>
  );
}

export function RecentPurchasesCardReceipt({ orderReceiptDetails = null }) {
  const receiptNumber = orderReceiptDetails || '';
  return (
    <div data-testid="receiptDetails" className="sui-flex sui-items-center">
      <span className="sui-mr-2">
        <Typography variant="body-base" weight="bold">
          Order/Receipt#
        </Typography>
      </span>
      <span>
        <Typography variant="body-base">{receiptNumber}</Typography>
      </span>
    </div>
  );
}

export function RecentPurchasesTileReceipt({ orderReceiptDetails = null, href = undefined }) {
  const receiptNumber = orderReceiptDetails || '';
  return (
    <div data-testid="receiptDetails" className="sui-flex sui-items-center">
      <span className="sui-mr-2">
        <Typography variant="body-base" weight="bold">
          Order/Receipt #:
        </Typography>
      </span>
      <span>
        <Link data-testid="receiptDetailsLink" href={href} onClick={publishViewOrderClickEvent}>
          {receiptNumber}
        </Link>
      </span>
    </div>
  );
}

RecentPurchasesTableReceipt.propTypes = {
  orderReceiptDetails: string,
};

RecentPurchasesCardReceipt.propTypes = {
  orderReceiptDetails: string,
};

RecentPurchasesTileReceipt.propTypes = {
  orderReceiptDetails: string,
  href: string,
};
